import React from "react";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import SortableItem from "./SortableItem";
import { useMedia } from "use-media";


export default function RootContainer(props) {
  const { id, items, active, activeId } = props;

  const { setNodeRef } = useDroppable({
    id
  });
  const isPC = useMedia({ minWidth: '1000px' });
  const rootContainerStyle = css`
  position: absolute;
  right: 0;
  width: ${isPC ? "300px" : "150px"};
  height: 80vh;
  background: #dadada74;
  display: flex;
  align-items: center;
  flex-flow: column;
  overflow-y: auto;
  padding-bottom: 10vh;
  h3 {
    border-bottom: 1px solid black;
  }
`;
  return (
    <SortableContext
      id={id}
      items={items}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef} css={rootContainerStyle}>
        <h3>word list</h3>
        {items?.length > 0 ?
          items.map((id) => (
            <SortableItem key={id} id={id} uniqueKey={id} active={active} activeId={activeId} />
          )) : " "}
      </div>
    </SortableContext >
  );
}
